import React from 'react';
import { Icon } from 'antd';

/**
 * @component
 * @name SearchingSpinner
 * @category Search Page
 * @description This component is present only during uuid requests, it is shown below [sort by cheaper/faster component]{@link PriceHeaderTab}
 * and below [rate cards]{@link MainResultCardComponent}
 * <br> <br>
 * **Example**
 * ```js
 *   <SearchingSpinner remainingTime={'1 min 12 sec'} style={{}} />
 *   <SearchingSpinner remainingTime={'2 min 22 sec'} />
 * ```
 * @param {string} remainingTime - remaining time of new rates of UUID request e.g. `1 min 12 sec`
 * @param {Object} [style=void] - css style
 */
export const SearchingSpinner = (props) => {
  return (
    <div
      className="testR1"
      style={{
        display: 'flex',
        justifyContent: 'center',
        ...(props.style && props.style),
      }}
    >
      <Icon type="loading" style={{ color: 'var(--blueColor)' }} />
      &nbsp;Searching&nbsp;
      <span>{props.remainingTime}</span>
    </div>
  );
};
